import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 pt-20" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg rounded-3xl border border-white/10 bg-white/5 p-10 text-center backdrop-blur">
        <p className="font-mono2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Checkout Cancelled</p>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-white">No charge was made.</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Your checkout session was closed before payment — nothing was billed and no subscription was created.
          Whenever you're ready, your package will be waiting.
        </p>
        <Link
          to="/pricing"
          data-testid="cancel-resume-btn"
          className="mt-8 inline-flex items-center gap-1.5 rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-500"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Pricing
        </Link>
      </div>
    </main>
  );
}
